import { render } from "./Promo-categories.vue?vue&type=template&id=98075426&scoped=true"
import script from "./Promo-categories.vue?vue&type=script&lang=js"
export * from "./Promo-categories.vue?vue&type=script&lang=js"

import "./Promo-categories.vue?vue&type=style&index=0&id=98075426&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98075426"]])

export default __exports__